"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'botTest.testResults.title': 'Risultati del test',
    'botTest.testResults.results': 'risultati',
    'botTest.testResults.result': 'Risultato',
    'botTest.testResults.metrics': 'Metriche',
    'botTest.testResults.totalMessages': 'Totale messaggi',
    'botTest.testResults.totalTokens': 'Totale token',
    'botTest.testResults.totalCost': 'Costo totale',
    'botTest.testResults.executionTime': 'Tempo di esecuzione',
    'botTest.testResults.averageResponseTime': 'Tempo medio di completamento domanda',
    'botTest.testResults.inputTokens': 'Token di input',
    'botTest.testResults.outputTokens': 'Token di output',
    'botTest.testResults.messageCount': 'Messaggi',
    'botTest.testResults.error': 'Errore',
    'botTest.testResults.response': 'Risposta IA',
    'botTest.testResults.questionGeneration': 'Generazione domande',
    'botTest.testResults.success': 'Successo',
    'botTest.testResults.tokens': 'Token',
    'botTest.testResults.cost': 'Costo',
    'botTest.testResults.status.pending': 'In attesa',
    'botTest.testResults.status.running': 'In esecuzione',
    'botTest.testResults.status.completed': 'Completato',
    'botTest.testResults.status.failed': 'Fallito',
    'botTest.testResults.questionsAndAnswers': 'Domande e Risposte',
    'botTest.testResults.question': 'Domanda',
    'botTest.testResults.questionLabel': 'D',
    'botTest.testResults.answerLabel': 'R',
    'botTest.testResults.answerStartTime': 'Tempo di risposta (primo token)',
    'botTest.testResults.no_results': 'Nessun risultato di test disponibile',
    'botTest.testResults.no_results_description': 'Esegui il test per vedere i risultati qui.',
};
